function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlip2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4mm",
    height: "4mm",
    viewBox: "0 0 4 4",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.64823,-14.557349)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.0579754,0.18708867)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 5.7062054,
    cy: 16.37026,
    r: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlip2);
export default __webpack_public_path__ + "static/media/slip-2.bcd3a78651ce68ad4b8c85605501177b.svg";
export { ForwardRef as ReactComponent };